/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchFilterOnBackground
 */
export interface SourcingSearchFilterOnBackground {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchFilterOnBackground
     */
    formerEmployer: string;
}

/**
 * Check if a given object implements the SourcingSearchFilterOnBackground interface.
 */
export function instanceOfSourcingSearchFilterOnBackground(value: object): value is SourcingSearchFilterOnBackground {
    if (!('formerEmployer' in value) || value['formerEmployer'] === undefined) return false;
    return true;
}

export function SourcingSearchFilterOnBackgroundFromJSON(json: any): SourcingSearchFilterOnBackground {
    return SourcingSearchFilterOnBackgroundFromJSONTyped(json, false);
}

export function SourcingSearchFilterOnBackgroundFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFilterOnBackground {
    if (json == null) {
        return json;
    }
    return {
        
        'formerEmployer': json['formerEmployer'],
    };
}

export function SourcingSearchFilterOnBackgroundToJSON(value?: SourcingSearchFilterOnBackground | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'formerEmployer': value['formerEmployer'],
    };
}

